import {
    defineStore,
} from 'pinia'
import {
    useContextStore,
} from '~~/stores/context'
import { PROVIDERS } from '#shared/providers'

export const useNotionStore = defineStore('notion', () => {
    const PROVIDER = PROVIDERS.NOTION

    const sites = ref([])

    const contextStore = useContextStore()
    contextStore.registerProvider(PROVIDER)

    const ctx = computed(() => contextStore.getContext(PROVIDER))
    watch(ctx, (newCtx, oldCtx) => {
        if (newCtx?.identityKey !== oldCtx?.identityKey) {
            sites.value = []
        }
    })

    async function fetchSites() {
        // TODO: implement
    }

    return { sites, fetchSites }
})
